// Generated by purs version 0.15.16
import * as API_Search from "../API.Search/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
var Expanded = /* #__PURE__ */ (function () {
    function Expanded() {

    };
    Expanded.value = new Expanded();
    return Expanded;
})();
var Collapsed = /* #__PURE__ */ (function () {
    function Collapsed() {

    };
    Collapsed.value = new Collapsed();
    return Collapsed;
})();
var resetWorkQueueUiState = function (defTeacher) {
    return function (defSemester) {
        return function (ui) {
            return {
                search: ui.search,
                expandedStudents: Data_Map_Internal.empty,
                teacher: Widgets_BetterSelect.setSelected(ui.teacher)(defTeacher),
                semester: Widgets_BetterSelect.setSelected(ui.semester)(defSemester)
            };
        };
    };
};
var initialWorkQueueUiState = /* #__PURE__ */ (function () {
    var teacherSel = {
        deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
        editable: Widgets_BetterSelect.defSelectConfig.editable,
        placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-teacher")),
        allowDeselect: false
    };
    var semesterSel = {
        deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
        editable: Widgets_BetterSelect.defSelectConfig.editable,
        placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-semester")),
        allowDeselect: false
    };
    return {
        expandedStudents: Data_Map_Internal.empty,
        search: Widgets_Search.initSearchState,
        teacher: Widgets_BetterSelect["initSelect$prime"]("teacher")(API_Search.teacherSearchAff)(teacherSel),
        semester: Widgets_BetterSelect["initSelect$prime"]("semester")(API_Search.semesterSearchAff)(semesterSel)
    };
})();
export {
    Expanded,
    Collapsed,
    initialWorkQueueUiState,
    resetWorkQueueUiState
};
//# sourceMappingURL=index.js.map
